var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 7.26676H4.99998V8.06676H11.3333V7.26676Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 9.26676H11.3333V10.0668H4.99998V9.26676Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 11.2668H4.99998V12.0668H11.3333V11.2668Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59998 15.4001H13.7333L13.7366 3.71343L13.6666 3.6101C12.8175 2.44487 11.7609 1.446 10.55 0.663431L10.4533 0.600098H2.59998V15.4001ZM12.9333 14.6001H3.39998V1.4001H9.59998V4.73343H12.9333V14.6001ZM10.4 3.93343V1.52794C11.3549 2.19603 12.2017 3.00727 12.9104 3.93343H10.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.8286802d39912277372938a2458099fc.svg";
export { ForwardRef as ReactComponent };